import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

export const apiCopyContact = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'copyContactsDefault',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      sourceImpcCode: payload.sourceImpcCode,
      targetImpcCode: payload.targetImpcCode,
    },
  });
  return axios.post(serviceURL, { headers: { 'Content-Type': 'text/plain' } });
};
